module.exports = __webpack_public_path__ + "img/customer-service.cdb99cc9.jpg";